import { IconX } from 'featherico';
import Button from '../../components/Button';
import Link from '../../components/Link';
import { useJustLaunched } from './service';
import styles from './style.m.less';

export function JustLaunchedBubble() {
    const { latestRelease, shouldShow, dismiss } = useJustLaunched();
    const canShowRelease = latestRelease && shouldShow;

    if (!canShowRelease) {
        return null;
    }

    return (
        <div className={styles.card}>
            <Link
                className={styles.cardLink}
                href={latestRelease.href}
                onClick={dismiss}
                openInNewTab
                hasTextStyle={false}
            >
                <span className={styles.cardTitle}>{latestRelease.teaser}</span>
            </Link>
            <Button kind="PLAIN" className={styles.cardClose} aria-label="Close" onClick={dismiss}>
                <IconX />
            </Button>
        </div>
    );
}
